var $6561a2d61d36bb44$exports = {};
$6561a2d61d36bb44$exports = {
    "valid": `\u{414}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{44B}\u{439}`
};


export {$6561a2d61d36bb44$exports as default};
//# sourceMappingURL=ru-RU.module.js.map
